import React from 'react';
import './CardsTiles.styles.scss';

function CardsTiles ({ items, handleItemClick, activeItemName = '', handleOverlayClick }) {
    return (
        <div className="CardsTiles">
            {items.map(({ name, count }, index) => (
                <div
                    key={index}
                    className={`
                        CardsTiles__item
                        ${name === activeItemName ? 'CardsTiles__item--active' : ''}
                        CardsTiles__item--${index}
                    `}
                    onClick={() => handleItemClick(name)}
                >
                    <div className="CardsTiles__item-text">
                        <div>{name}</div>
                        <div>{count}</div>
                    </div>
                </div>
            ))}
            <div
                className={`CardsTiles__overlay ${activeItemName === '' ? 'CardsTiles__overlay--hidden' : ''}`}
                onClick={handleOverlayClick}
            />
        </div>
    );
}

export default CardsTiles;